import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MyAccountMobileComponent } from './my-account-mobile.component';

@NgModule({
  declarations: [MyAccountMobileComponent],
  imports: [CommonModule, MatIconModule, MatListModule, MatDialogModule],
})
export class MyAccountMobileModule {}
